import DateRange from './dateRange';
import type { DateRangeProps } from './interface';

export type { DateRangeProps };

export default DateRange;
